/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface SetPricingAgreementTurnRequest
 */
export interface SetPricingAgreementTurnRequest {
  /**
   *
   * @type {string}
   * @memberof SetPricingAgreementTurnRequest
   */
  agreementId: string;
  /**
   *
   * @type {string}
   * @memberof SetPricingAgreementTurnRequest
   */
  turn?: string | null;
  /**
   *
   * @type {string}
   * @memberof SetPricingAgreementTurnRequest
   */
  turnTime?: string | null;
}

/**
 * Check if a given object implements the SetPricingAgreementTurnRequest interface.
 */
export function instanceOfSetPricingAgreementTurnRequest(
  value: object,
): value is SetPricingAgreementTurnRequest {
  if (!("agreementId" in value) || value["agreementId"] === undefined)
    return false;
  return true;
}

export function SetPricingAgreementTurnRequestFromJSON(
  json: any,
): SetPricingAgreementTurnRequest {
  return SetPricingAgreementTurnRequestFromJSONTyped(json, false);
}

export function SetPricingAgreementTurnRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): SetPricingAgreementTurnRequest {
  if (json == null) {
    return json;
  }
  return {
    agreementId: json["agreementId"],
    turn: json["turn"] == null ? undefined : json["turn"],
    turnTime: json["turnTime"] == null ? undefined : json["turnTime"],
  };
}

export function SetPricingAgreementTurnRequestToJSON(
  json: any,
): SetPricingAgreementTurnRequest {
  return SetPricingAgreementTurnRequestToJSONTyped(json, false);
}

export function SetPricingAgreementTurnRequestToJSONTyped(
  value?: SetPricingAgreementTurnRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    agreementId: value["agreementId"],
    turn: value["turn"],
    turnTime: value["turnTime"],
  };
}
